<template>
  <div class="container">
    <h1>
      Pages
      <router-link class="btn btn-success btn-sm pull-right" :to="`/pages/new`" v-if="isAdmin">
        New
      </router-link>
    </h1>

    <table class="table table-sm">
      <thead class="thead-inverse">
        <tr>
          <th class="minsize">Title</th>
          <th class="minsize d-none d-md-table-cell">Link(s)</th>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item._id">
          <td>
            <strong>{{ item.title }}</strong>
          </td>
          <td class="d-none d-md-table-cell">
            <a :href="item.title.toLowerCase().replace(/ /g, '-')">{{ item.title.toLowerCase().replace(/ /g, '-') }}</a>
            <span v-if="item.link"> <strong>OR</strong> <a :href="item.link">{{ item.link }}</a></span>
          </td>
          <td>
            {{ item.description }}
          </td>
          <td class="text-right no-wrap">
            <router-link class="btn btn-primary btn-sm" :to="`/pages/${item._id}/edit`" v-if="isAdmin">
              <span class="d-none d-md-inline">Edit</span>
              <i class="fa fa-pencil d-md-none" aria-hidden="true"></i>
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "page-index",
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      items: state => state.pages.all
    })
  },
  methods: {
    ...mapActions({
      pagesAll: "pages/all"
    }),
    async getData() {
      try {
        this.pagesAll({ params: "sort=title" });
        this.$embers.pageData("Pages");
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.minsize {
  min-width: 8em;
}
</style>
